/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DairyKwhPerM3Comparison { 
    kwH_per_m3milk?: number;
    date?: string;
}

